function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckSquare = function SvgCheckSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-13a2 2 0 0 0-2-2h-13Zm11.415 4.311c.657.505.78 1.447.274 2.103L9.238 15.65 5.04 12.152a1.501 1.501 0 0 1 1.921-2.305l1.802 1.501 4.049-5.264a1.5 1.5 0 0 1 2.104-.274Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgCheckSquare;